import { Input } from '@douyinfe/semi-ui';
import { NavLink, useHistory } from '@jupiter/plugin-runtime/router';
import { IconSearch } from '@douyinfe/semi-icons';
import { useState } from 'react';
import { ScopesMap } from '@/consts/scope';
import { useScope } from '@/hooks/useScope';
import { reportQuerySearch } from '@/report';

export const ScopeLayout: React.FC = ({ children }) => {
  const history = useHistory();
  const scope = useScope();
  const [search, setSearch] = useState<string | undefined>();
  const toSearchPage = (keyword = '') => {
    history.push(
      `/search?q=${encodeURIComponent(keyword)}&page=1&limit=10&scope=${scope}`,
    );
    reportQuerySearch();
  };
  return (
    <div className="h-screen w-full overflow-auto min-w-[1200px] bg-[#F9F9F9]">
      <div className="bg-white fixed top-[60px] z-50 w-full">
        <div className="mx-auto min-w-[808px] max-w-[1200px] h-16 py-4 flex w-full justify-between">
          <div className={' h-full flex items-center space-x-6'}>
            <div>
              <NavLink
                to={`/`}
                exact={true}
                style={{
                  padding: '8px 12px',
                  fontSize: '14px',
                  color: '#171A1C',
                }}
                activeStyle={{
                  color: '#171A1C',
                  padding: '8px 12px',
                  background: '#2E32380D',
                  borderRadius: '3px',
                  fontWeight: 500,
                }}>
                综合
              </NavLink>
            </div>
            {Object.entries(ScopesMap).map(([key, value]) => (
              <div key={value}>
                <NavLink
                  to={`/${key}`}
                  exact={true}
                  style={{
                    padding: '8px 12px',
                    fontSize: '14px',
                    color: '#171A1C',
                  }}
                  activeStyle={{
                    color: '#171A1C',
                    padding: '8px 12px',
                    background: '#2E32380D',
                    borderRadius: '3px',
                    fontWeight: 500,
                  }}>
                  {value}
                </NavLink>
              </div>
            ))}
          </div>
          <div className="md:block">
            <Input
              placeholder={'搜您想搜'}
              value={search}
              onChange={setSearch}
              suffix={
                <IconSearch
                  className="cursor-pointer"
                  onClick={() => {
                    toSearchPage(search);
                  }}
                />
              }
              onEnterPress={() => {
                toSearchPage(search);
              }}
              style={{
                width: '240px',
              }}
            />
          </div>
        </div>
      </div>
      <div className="mt-16">{children}</div>
    </div>
  );
};
